import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Skeleton, ToggleButton, ToggleButtonGroup, FormHelperText } from '@mui/material';

// ----------------------------------------------------------------------

RHFToggleButton.propTypes = {
  name: PropTypes.string.isRequired,
  states: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

export default function RHFToggleButton({ states, name, loading = false, disable, ...other }) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) =>
        loading ? (
          <Skeleton width={'100%'}>
            <ToggleButtonGroup />
          </Skeleton>
        ) : (
          <>
            <ToggleButtonGroup
              color="primary"
              fullWidth
              sx={{ height: '2rem' }}
              disabled={disable}
              exclusive
              onChange={(index, newValue) => {
                if (newValue !== null) field.onChange(newValue);
              }}
              value={field.value}
              aria-label="userState"
              {...other}
            >
              {states.map((state, index) => (
                <ToggleButton value={index} key={index}>
                  {state}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
            <FormHelperText error={!!error}>{error?.message}</FormHelperText>
          </>
        )
      }
    />
  );
}
